module.exports = __webpack_public_path__ + "img/24e94675dac5abcb28468c3d0421f6e1.png";